const selectDeviceOutputs = state => state.data.deviceOutputs

const DeviceOutputDataStoreSelectors = {
  deviceOutputs: selectDeviceOutputs
}

export default DeviceOutputDataStoreSelectors
